import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ProjectCard } from '../components/ProjectCard';
import { FadeIn } from '../components/ui/FadeIn';
import { Button } from '../components/ui/Button';
interface ProjectsPageProps {
  onNavigate: (page: 'landing' | 'projects') => void;
}
const projects = [{
  title: 'Apex Finance',
  description: 'Automated reconciliation platform for enterprise fintech teams.',
  category: 'Fintech',
  thumbnailColor: 'bg-blue-600',
  likes: 428
}, {
  title: 'Loom & Leaf',
  description: 'Direct-to-consumer sustainable furniture marketplace.',
  category: 'E-commerce',
  thumbnailColor: 'bg-green-600',
  likes: 315
}, {
  title: 'Chronos',
  description: 'AI-powered scheduling assistant for remote teams.',
  category: 'SaaS',
  thumbnailColor: 'bg-purple-600',
  likes: 892
}, {
  title: 'Vitality Health',
  description: 'Patient portal and telemedicine booking system.',
  category: 'Healthcare',
  thumbnailColor: 'bg-red-500',
  likes: 245
}, {
  title: 'Structura',
  description: 'Project management for civil engineering firms.',
  category: 'B2B',
  thumbnailColor: 'bg-orange-500',
  likes: 156
}, {
  title: 'Velvet',
  description: 'Luxury fashion rental platform with subscription model.',
  category: 'Consumer',
  thumbnailColor: 'bg-neutral-900',
  likes: 567
}];
export function ProjectsPage({
  onNavigate
}: ProjectsPageProps) {
  return <main className="min-h-screen w-full bg-white selection:bg-neutral-900 selection:text-white pt-24" data-id="element-105">
      <Navbar onNavigate={onNavigate} currentPage="projects" data-id="element-106" />

      {/* Header */}
      <section className="px-6 pb-12 md:pb-20 pt-10" data-id="element-107">
        <div className="max-w-3xl mx-auto text-center" data-id="element-108">
          <FadeIn data-id="element-109">
            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-neutral-900 mb-6" data-id="element-110">
              Projects Launched
            </h1>
            <p className="text-xl text-neutral-500 leading-relaxed" data-id="element-111">
              A collection of software, platforms, and products built and
              shipped by Stasis Studio.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Filter / Tabs (Visual only for now) */}
      <section className="px-6 mb-8" data-id="element-112">
        <div className="max-w-4xl mx-auto border-b border-neutral-100 flex gap-8 overflow-x-auto no-scrollbar" data-id="element-113">
          <button className="pb-4 text-sm font-medium text-neutral-900 border-b-2 border-neutral-900 whitespace-nowrap" data-id="element-114">
            All Projects
          </button>
          <button className="pb-4 text-sm font-medium text-neutral-500 hover:text-neutral-900 transition-colors whitespace-nowrap" data-id="element-115">
            SaaS
          </button>
          <button className="pb-4 text-sm font-medium text-neutral-500 hover:text-neutral-900 transition-colors whitespace-nowrap" data-id="element-116">
            Fintech
          </button>
          <button className="pb-4 text-sm font-medium text-neutral-500 hover:text-neutral-900 transition-colors whitespace-nowrap" data-id="element-117">
            E-commerce
          </button>
          <button className="pb-4 text-sm font-medium text-neutral-500 hover:text-neutral-900 transition-colors whitespace-nowrap" data-id="element-118">
            Mobile Apps
          </button>
        </div>
      </section>

      {/* Project List */}
      <section className="px-6 pb-32" data-id="element-119">
        <div className="max-w-4xl mx-auto" data-id="element-120">
          <div className="flex flex-col gap-2" data-id="element-121">
            {projects.map((project, index) => <ProjectCard key={index} index={index} {...project} data-id="element-122" />)}
          </div>

          <div className="mt-16 text-center" data-id="element-123">
            <FadeIn delay={0.4} data-id="element-124">
              <p className="text-neutral-500 mb-6" data-id="element-125">Have a project in mind?</p>
              <Button variant="primary" icon data-id="element-126">
                Start your project brief
              </Button>
            </FadeIn>
          </div>
        </div>
      </section>

      <Footer data-id="element-127" />
    </main>;
}